import React from 'react';
import './TransactionDetails.scss'; // Assuming your SASS file is named TransactionDetails.scss
import transactionData from './transactionData.json'; // Adjust the path as necessary
import { BsCopy } from "react-icons/bs";

const TransactionDetails = () => {
  const data = transactionData; // No need to pass data as a prop anymore

  const maskBankCard = (card) => '**** **** **** ' + card.slice(-4);

  return (
    <div className="transaction-details">
      {/* Reminder Line */}
      <div className="line reminder">{data.reminder}</div>

      {/* Username Line */}
      <div className="line user">
        <div className="icon-circle">
          {/* Placeholder for user icon */}
        </div>
        <span>{data.username}</span>
      </div>

      {/* Repeat for each property in the transactionData */}
      {/* ... */}

      {/* Payment Method */}
      <div className="line">
        <div className="label">Payment Method:</div>
        <div className="value">{data.payment_method} <BsCopy /></div>
      </div>
      <hr />
      {/* Bank Card Masked */}
      <div className="line">
        <div className="label">Bank Card:</div>
        <div className="value">**** **** **** {data.bank_card_number_ending}</div>
      </div>
      <hr />
      {/* Bank Name */}
      <div className="line">
        <div className="label">Bank Name:</div>
        <div className="value">{data.bank_name}</div>
      </div>
      <hr />
      {/* Bank Card Number Ending */}
      <div className="line">
        <div className="label">Card Ending:</div>
        <div className="value">{maskBankCard(data.bank_card_masked)}</div>
      </div>
    </div>
  );
};

export default TransactionDetails;
